import {Component, Input, OnInit} from "@angular/core";
@Component({
    selector: 'error-validator',
    templateUrl: './error-validator.component.html',
    styleUrls: ['./error-validator.component.scss'],
    standalone: false
})

export class ErrorValidatorComponent implements OnInit{
  
  @Input() formSubmitted:boolean;
  @Input() formModelRef:any;
  @Input() errorCodesList:any;
  @Input() inputType = "";

  constructor() {
    
  }

  ngOnInit() {
    //console.log(this.errorCodesList)
    return;
  }
  
}

